import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

 

  constructor(
   ){ }

  ngOnInit() {
    
  }


}
